// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Routers from './router'
import VueBus from 'vue-bus'
import App from './app'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'
import api from './api/index'
import store from './store/index'
import moment from "moment"

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import swiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

// import js
import common from './assets/js/public.js'
import action from './assets/js/action.js'

// import css
import './assets/css/layout.css'
import './assets/css/custom.css'
import './assets/css/style.css'
import './assets/css/animate.css'

Vue.use(VueRouter);
Vue.use(VueBus);

Vue.use(ViewUI);
Vue.prototype.$echarts = echarts;
Vue.use(BaiduMap, {
    ak: 'C3Om4fqXeFmYHIA57PWQ96O2Vz0DpEAH'
});
Vue.use(api);
Vue.prototype.$api = api;
Vue.prototype.$moment = moment;
Vue.prototype.$video = Video;
Vue.use(preview);
Vue.use(swiper);
Vue.prototype.$common = common;
Vue.prototype.$action = action;

// The routing configuration
const RouterConfig = {
  routes: Routers
};

Vue.config.productionTip = false;

/* eslint-disable no-new */

new Vue({
    el: '#app',
    router: Routers,
    api,
    store,
    render: h => h(App)
});

/* LoadingBar */
Routers.beforeEach((to, from, next) => {
    ViewUI.LoadingBar.start();
    next();
});
Routers.afterEach(route => {
    ViewUI.LoadingBar.finish();
});



// WEBPACK FOOTER //
// ./src/main.js